import { useEffect, useState } from 'react'

import { getTotalUsers } from '_services/data-explorer'

export default function useTotalUsers(payload) {
  const [result, setResult] = useState()

  useEffect(() => {
    getTotalUsers(payload).then((totalUsers) => {
      setResult(totalUsers)
    })
  }, [payload])

  return [result]
}
